class ProductInformation extends HTMLElement {
  connectedCallback() {
    this.mainSlider = this.querySelector(this.getAttribute('slider-selector'))
    this.initSlider()
    this.initSliderMobileOnly()
  }

  getBulletString(index) {
    const pageStrings = this.mainSlider.getAttribute('bullet-items').split(',')
    return pageStrings[index]
  }

  get mobileOnlySliderSelector() {
    return this.getAttribute('mobile-only-slider-selector')
  }

  initSlider() {
    const swiperParams = {
      autoHeight: false,
      centeredSlides: false,
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${this.getBulletString(
            index
          )}</span>`
        },
      },
    }

    Object.assign(this.mainSlider, swiperParams)
    this.mainSlider.initialize()
  }

  initSliderMobileOnly() {
    const swiperEl = this.querySelector(
      `swiper-container${this.mobileOnlySliderSelector}`
    )

    if (!swiperEl) {
      return
    }

    const swiperParams = {
      autoHeight: true,
      slidesPerView: 1.1,
      spaceBetween: 15,
      noSwiping: false,
      slidesOffsetBefore: window.innerWidth * 0.04,
      slidesOffsetAfter: window.innerWidth * 0.04,
      breakpoints: {
        990: {
          slidesPerView: 4,
          noSwiping: true,
          spaceBetween: 30,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    }

    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
  }
}

window.customElements.define('product-information', ProductInformation)
